import { Flex } from '@repo/ui/Flex';
import { Icon } from '@repo/ui/Icon';

import s from './Footer.module.css';

export interface FooterTexts {
  copyright?: string;
  privacyPolicy?: string;
  privacyPolicyUrl?: string;
  poweredBy?: string;
  surveyUrl?: string;
}

export interface FooterProps {
  /** Text and URL content for the footer - all fields have sensible defaults */
  texts?: FooterTexts;
}

const DEFAULTS = {
  copyright: `©${new Date().getFullYear()} Narvar`,
  privacyPolicy: 'Privacy Policy',
  privacyPolicyUrl: 'https://corp.narvar.com/privacy-policy/',
  poweredBy: 'Powered by Narvar',
  surveyUrl: 'https://corp.narvar.com/survey?product=pdx',
};

/**
 * Pure presentational Footer component.
 * Decoupled from pdp-specific dependencies by accepting all content as props.
 * All fields have sensible defaults and can be overridden.
 */
export const Footer = ({ texts }: FooterProps) => {
  const copyright = texts?.copyright ?? DEFAULTS.copyright;
  const privacyPolicy = texts?.privacyPolicy ?? DEFAULTS.privacyPolicy;
  const privacyPolicyUrl = texts?.privacyPolicyUrl ?? DEFAULTS.privacyPolicyUrl;
  const poweredBy = texts?.poweredBy ?? DEFAULTS.poweredBy;
  const surveyUrl = texts?.surveyUrl ?? DEFAULTS.surveyUrl;

  return (
    <div className={s.wrapper}>
      <Flex
        alignItems="center"
        as="footer"
        gap="g-400"
        justifyContent="space-between"
        padding="p-600"
        className={s.container}
      >
        <Flex gap="g-200" className={s.legal}>
          <span>{copyright}</span>
          <span>•</span>
          <span>
            <a
              href={privacyPolicyUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {privacyPolicy}
            </a>
          </span>
        </Flex>
        <a
          className={s.poweredBy}
          href={surveyUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon className={s.narvarIconDark} name="narvar-logo" size="font" />
          {poweredBy}
        </a>
      </Flex>
    </div>
  );
};
